import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLanguage12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconLanguage12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M0 1h7v2.5a.5.5 0 0 1-1 0V2H4v6h1a.5.5 0 0 1 0 1H2a.5.5 0 0 1 0-1h1V2H1v1.5a.5.5 0 0 1-1 0zm8.79 7.636.308-.205a2.28 2.28 0 0 0 1.014-1.894V6H5.5V5h2.75V3.4a.5.5 0 1 1 1 0V5H12v1h-.888v.537a3.28 3.28 0 0 1-1.297 2.61l1.483.742a.5.5 0 0 1-.447.895L8.863 9.79l-2.139 1.426-.555-.833 1.683-1.121A3.18 3.18 0 0 1 6.41 6.6h1c0 .824.465 1.578 1.203 1.947z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLanguage12);
